/**
 * Search mode options.
 * @public
 */
enum SearchMode {
	/**
	 * Search field with default appearance.
	 * @public
	 */
	Default = "Default",

	/**
	 * Search field with additional scope select.
	 * @public
	 */
	Scoped = "Scoped",
}

export default SearchMode;
